/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STJobQueueStatusApi {
  async GetStatus(processQueueGu : string) : Promise<st.JobQueueStatusInfo> {
    return await componentApi.call('st', 'st-job-queue-status', 'STJobQueueStatusApi', 'GetStatus', {
      processQueueGu,
    });
  }
  async GetStatusList(includeAllUnread : boolean) : Promise<st.JobQueueStatusListResponse> {
    return await componentApi.call('st', 'st-job-queue-status', 'STJobQueueStatusApi', 'GetStatusList', {
      includeAllUnread,
    });
  }
  async GetHistoricalJobs(beforeDate : string, afterDate : string) : Promise<Array<st.JobQueueStatusInfo>> {
    return await componentApi.call('st', 'st-job-queue-status', 'STJobQueueStatusApi', 'GetHistoricalJobs', {
      beforeDate,
      afterDate,
    });
  }
  async AbortJobs(processQueueGus : Array<string>) : Promise<st.JobQueueStatusListResponse> {
    return await componentApi.call('st', 'st-job-queue-status', 'STJobQueueStatusApi', 'AbortJobs', {
      processQueueGus,
    });
  }
}
export default new STJobQueueStatusApi()
